import type { IOpportunityNote } from './../types/note/models'
import { makeNoteService } from '~/cynqueModules/factoriesForServices/notes'

export const {
  createNote: createOpportunityNote,
  updateNote: updateOpportunityNote,
  deleteNote: deleteOpportunityNote,
} = makeNoteService<IOpportunityNote>(
  '/api/opportunitynotes',
  'opportunityNote'
)
